import { getKey } from '../getKey';
import { getStorage } from '../getStorage';
function setStorageItem(key, value, storageType, userId) {
    var storage = getStorage(storageType);
    if (!storage) {
        return;
    }
    var itemKey = getKey(key, userId);
    try {
        var jsonValue = typeof value === 'undefined' ? 'null' : JSON.stringify(value);
        storage.setItem(itemKey, jsonValue);
    }
    catch (_a) {
        /* Do nothing */
    }
}
export function setGlobalItem(key, value, storageType) {
    if (storageType === void 0) { storageType = "localStorage" /* StorageType.LocalStorage */; }
    return setStorageItem(key, value, storageType);
}
export function setUserItem(userId, key, value, storageType) {
    if (storageType === void 0) { storageType = "localStorage" /* StorageType.LocalStorage */; }
    return setStorageItem(key, value, storageType, userId);
}
//# sourceMappingURL=setItem.js.map